import InputDatetime from "../../../../components/input/input-datetime.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const {
        occurrenceDetailsCondition,
        occurrenceDetailsNature,
        occurrenceDetailsNeighborhood,
        occurrenceCityFact
    } = useReportFiltersFetch({
        fetchOccurrencesDetailsCondition: true,
        fetchOccurrenceDetailsNature: true,
        fetchOccurrencesDetailsNeighborhood: true,
        fetchOccurrenceCityFact: true,
    });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">
                    <InputDatetime
                        id="dtStart"
                        label="Data/hora inicial *"
                        dateFormat="LL"
                        classNameWrapper="w-full"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                    />

                    <InputDatetime
                        id="dtEnd"
                        label="Data/hora final *"
                        dateFormat="LL"
                        classNameWrapper="w-full"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                    />

                    <SelectComponent
                        id="condition"
                        label="Condição dos indivíduos"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceDetailsCondition}
                        value={filters.condition}
                        onChange={(value) => setFilters(prev => ({ ...prev, condition: value }))}
                    />

                    <SelectComponent
                        id="nature"
                        label="Natureza"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceDetailsNature}
                        value={filters.nature}
                        onChange={(value) => setFilters(prev => ({ ...prev, nature: value }))}
                    />

                    <SelectComponent
                        id="neighborhood"
                        label="Bairro"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceDetailsNeighborhood}
                        value={filters.neighborhood}
                        onChange={(value) => setFilters(prev => ({ ...prev, neighborhood: value }))}
                    />

                    <SelectComponent
                        id="cityFact"
                        label="Município do fato"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceCityFact}
                        value={filters.cityFact}
                        onChange={(value) => setFilters(prev => ({ ...prev, cityFact: value }))}
                    />

                    <InputCheckbox
                        id="onlyMyCity"
                        label="Apenas ocorrências da minha corporação"
                        className="pl-1"
                        checked={filters.onlyMyCity}
                        onChange={(e) => setFilters(prev => ({ ...prev, onlyMyCity: e.target.checked}))}
                    />

                    <InputCheckbox
                        id="archivedOccurrences"
                        label="Contabilizar ocorrências arquivadas"
                        className="pl-1"
                        checked={filters.archivedOccurrences}
                        onChange={(e) => setFilters(prev => ({ ...prev, archivedOccurrences: e.target.checked }))}
                    />

                    <InputCheckbox
                        id="isFlagrant"
                        label="Flagrante"
                        className="pl-1"
                        checked={filters.isFlagrant}
                        onChange={(e) => setFilters(prev => ({ ...prev, isFlagrant: e.target.checked }))}
                    />

                    <InputCheckbox
                        id="tableMode"
                        label="Modo tabela"
                        className="pl-1"
                        checked={filters.tableMode}
                        onChange={(e) => setFilters(prev => ({ ...prev, tableMode: e.target.checked }))}
                    />
                </form>
            </div>
        </>
    )
}